"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardsGrid = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var theme_1 = require("../../../../mantine-theme/src");
var CardsGrid_styles_1 = __importDefault(require("./CardsGrid.styles"));
function CardsGrid(_a) {
    var _b = _a.gutter, gutter = _b === void 0 ? 'md' : _b, _c = _a.cardsPerRow, cardsPerRow = _c === void 0 ? 1 : _c, _d = _a.grow, grow = _d === void 0 ? false : _d, children = _a.children, className = _a.className, themeOverride = _a.themeOverride, others = __rest(_a, ["gutter", "cardsPerRow", "grow", "children", "className", "themeOverride"]);
    var classes = CardsGrid_styles_1.default({
        cardsPerRow: cardsPerRow,
        gutter: gutter,
        grow: grow,
        theme: theme_1.useMantineTheme(themeOverride),
    });
    return (react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.grid, className) }, others), children));
}
exports.CardsGrid = CardsGrid;
CardsGrid.displayName = '@mantine/core/CardsGrid';
